import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { subscribeVersionUpdate, reloadNow } from '../utils/versionCheck';

const UpdateAvailableSnackbar = () => {
  const [open, setOpen] = useState(false);
  const [escalated, setEscalated] = useState(false);

  useEffect(() => {
    return subscribeVersionUpdate((state) => {
      setOpen(true);
      if (state.escalated) setEscalated(true);
    });
  }, []);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ '& .MuiPaper-root': { minWidth: 320 } }}
    >
      <Alert
        severity={escalated ? 'warning' : 'info'}
        sx={{ alignItems: 'center', width: '100%' }}
        action={
          <Button
            color="inherit"
            size="small"
            startIcon={<RefreshIcon fontSize="small" />}
            onClick={reloadNow}
          >
            重新載入
          </Button>
        }
      >
        {escalated
          ? '有新版本，請儲存後重新載入'
          : '新版本可用，請儲存後重新載入'}
      </Alert>
    </Snackbar>
  );
};

export default UpdateAvailableSnackbar;
